import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { rememberVisit } from "@/lib/signupSource";

// Before the router can rewrite the URL and lose its utm tags
rememberVisit();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
